// extracted by mini-css-extract-plugin
export var avatarContainer = "_6t-0";
export var avatarTypingWave = "_6t-i";
export var gray = "_6t-f";
export var green = "_6t-c";
export var icon = "_6t-9";
export var image = "_6t-1";
export var lg = "_6t-6";
export var md = "_6t-5";
export var presenceDot = "_6t-b";
export var red = "_6t-d";
export var sm = "_6t-4";
export var status = "_6t-a";
export var typingDot = "_6t-h";
export var typingPill = "_6t-g";
export var xl = "_6t-7";
export var xs = "_6t-3";
export var xxl = "_6t-8";
export var xxs = "_6t-2";
export var yellow = "_6t-e";